import urls from "../global/constants/UrlConstants";
import Dashboard from "../assets/icons/dashboard.svg";
import Leads from "../assets/icons/Leads.svg";
import Teams from "../assets/icons/Team.svg";
import Settings from "../assets/icons/settings.svg";
import SettingsBlack from "../assets/icons/Settings-black.svg";
import Projects from "../assets/icons/Projects.svg";
import MetaData from "../assets/icons/metaData.svg";
import Attendance from "../assets/icons/AttendanceImg.svg";
import SalarySlip from "../assets/icons/SalaryImg.svg";
import Leave from "../assets/icons/LeaveImg.svg";
import Reports from "../assets/icons/reports.svg";
import Communication from "../assets/icons/Communication.svg";
import UserIcon from "../assets/icons/User.svg";
import Roles from "../assets/icons/roles.svg";
import Coin from "../assets/icons/coin.svg";
import Bills from "../assets/icons/bills.svg";
import FileIcon from "../assets/icons/file.svg";
import Headphones from "../assets/icons/Headphones.svg";
import Clock from "../assets/icons/clock.svg";
import SignIn from "../assets/icons/Sign_in_circle.svg";
import BellIcon from "../assets/icons/bell.svg";
import FormIcon from "../assets/icons/fluent_pen.svg";

// import { store } from "./store";
import { AuthMap } from "../Models/Interface";
import strings from "../global/constants/StringConstants";
import { store } from "./store";

export const ListOfMenus = [
  {
    icon: Dashboard,
    activeIcon: Dashboard,
    text: "",
    key: "ADMIN",
    link: urls.dashboardViewPath,
    pageName: strings.DASHBOARD,
    name: "Dashboard",
  },
  // {
  //   icon: Dashboard,
  //   activeIcon: Dashboard,
  //   text: "",
  //   key: "CRM",
  //   link: urls.dashboardViewPathCrm,
  //   pageName: strings.DASHBOARDCRM,
  //   name: "Dashboard",
  // },
  // {
  //   icon: Dashboard,
  //   activeIcon: Dashboard,
  //   text: "",
  //   key: "HR",
  //   link: urls.dashboardViewPathHr,
  //   pageName: strings.DASHBOARDHR,
  //   name: "Dashboard",
  // },
  {
    icon: Dashboard,
    activeIcon: Dashboard,
    text: "",
    key: "MY-Dashboard",
    link: urls.dashboardViewPathMy,
    pageName: strings.DASHBOARDMY,
    name: "Dashboard",
  },
  {
    icon: Leads,
    activeIcon: Leads,
    text: "",
    key: "Leads",
    link: urls.dashboardViewPath,
    pageName: "Leads",
    name: "Leads",
    subMenu: [
      {
        subMenuPageName: "Lead Center",
        icon: Leads,
        activeIcon: Leads,
        subSubMenu: [
          {
            icon: Leads,
            activeIcon: Leads,
            text: "All Lead",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "All Lead",
            link: urls.ALLLEADFORMLIST,
            pageName: strings.ALLLEADLIST,
            name: "All Lead",
          },
          {
            icon: Leads,
            activeIcon: Leads,
            text: "My lead",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "My Leads",
            link: urls.mylead,
            pageName: strings.MYLEADS,
            name: "My Lead",
          },
          {
            icon: Teams,
            activeIcon: Teams,
            text: "Team leads",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Team Leads",
            link: urls.teamleads,
            pageName: strings.TEAMLEADS,
            name: "Team leads",
          },
            {
            icon: Headphones,
            activeIcon: Headphones,
            text: "Service leads",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Service Leads",
            link: urls.serviceleads,
            pageName: strings.SERVICELEADS,
            name: "Service leads",
          },
             {
            icon: BellIcon,
            activeIcon: BellIcon,
            text: "Subscribe Leads",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Subscribe Leads",
            link: urls.subscribeleads,
            pageName: strings.SUBSCRIBELEADS,
            name: "Subscribe Leads",
          },
          // {
          //   icon: Leads,
          //   activeIcon: Leads,
          //   text: "Lead Transfer",
          //   subtext: "Est arcu pharetra proin pellentesque",
          //   key: "Lead Transfer",
          //   link: urls.bulkAssign,
          //   pageName: strings.BULKASSIGN,
          //   name: "Lead Transfer",
          // },
      
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Archive Lead List",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Archive Lead List",
            link: urls.archiveLead,
            pageName: strings.ARCHIVELEAD,
            name: "Archive Lead List",
          },
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Unmerged Leads",
            subtext: "Staging inbox — move portal/Meta leads into All Leads",
            key: "All Lead",
            link: urls.unmergedLeads,
            pageName: strings.UNMERGEDLEADS,
            name: "Unmerged Leads",
          },
        ],
      },
      {
        subMenuPageName: "Bulk Upload",
        icon: FileIcon,
        activeIcon: FileIcon,
        subSubMenu: [
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Leads Bulk Upload",
            subtext: "Upload CSV/XLSX → map → preview → save as a set",
            key: "Leads Bulk Upload",
            link: urls.leadsBulkUploadPath,
            pageName: "Leads Bulk Upload",
            name: "Leads Bulk Upload",
          },
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Bulk upload sets",
            subtext: "Dataset names, uploaded files & tracking",
            key: "Leads Bulk Upload Sets",
            link: urls.leadsBulkUploadSetsPath,
            pageName: "Leads Bulk Upload",
            name: "Bulk upload sets",
          },
        ],
      },
      {
        subMenuPageName: "Call Data",
        icon: Headphones,
        activeIcon: Headphones,
        subSubMenu: [
          {
            icon: Headphones,
            activeIcon: Headphones,
            text: "Call Datasets",
            subtext: "Bulk call lists — not leads until you convert them",
            key: "Call Datasets",
            link: urls.callDatasetsPath,
            pageName: "Call Datasets",
            name: "Call Datasets",
          },
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Upload Call Data",
            subtext: "Create a dataset or add more rows to one",
            key: "Upload Call Data",
            link: urls.callDatasetUploadPath,
            pageName: "Call Datasets",
            name: "Upload Call Data",
          },
        ],
      },
    ],
  },
  {
    icon: Roles,
    activeIcon: Roles,
    text: "",
    key: "Channel Partner",
    link: urls.channelPartnersPath,
    pageName: "Partners",
    name: "Partners",
    subMenu: [
      {
        subMenuPageName: "Partners",
        icon: Roles,
        activeIcon: Roles,
        subSubMenu: [
          {
            icon: Roles,
            activeIcon: Roles,
            text: "Partners",
            subtext: "Create & manage partners across orgs & projects",
            key: "Channel Partners",
            link: urls.channelPartnersPath,
            pageName: "Partners",
            name: "Partners",
          },
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Bulk Upload",
            subtext: "Bulk onboard partners (XLSX)",
            key: "CP Bulk Upload",
            link: urls.cpBulkUploadPath,
            pageName: "CP Bulk Upload",
            name: "Bulk Upload",
          },
          {
            icon: Leads,
            activeIcon: Leads,
            text: "Add Partner Lead",
            subtext: "Add a lead for a partner",
            key: "Add CP Lead",
            link: urls.cpAddLeadPath,
            pageName: "Add CP Lead",
            name: "Add Partner Lead",
          },
        ],
      },
    ],
  },
  {
    icon: FormIcon,
    activeIcon: FormIcon,
    text: "",
    key: "Lead Form",
    link: urls.LEADFORMLIST,
    pageName: strings.LEADFORMLIST,
    name: "Form",
  },
  {
    icon: Headphones,
    activeIcon: Headphones,
    text: "",
    key: "Feedback",
    link: urls.FEEDBACKLIST,
    pageName: strings.FEEDBACKLIST,
    name: "Feedback",
  },
  {
    icon: SignIn,
    activeIcon: SignIn,
    text: "",
    key: "Registrations",
    link: urls.REGISTRATIONSLIST,
    pageName: strings.REGISTRATIONSLIST,
    name: "Registrations",
  },
  {
    icon: Coin,
    activeIcon: Coin,
    text: "",
    key: "Payment",
    link: urls.PAYMENTLIST,
    pageName: strings.PAYMENTLIST,
    name: "Payment",
  },
  {
    icon: Communication,
    activeIcon: Communication,
    text: "",
    key: "Marketing",
    link: urls.whatsappMarketingPath,
    pageName: strings.WHATSAPP_MARKETING,
    name: "Marketing",
    subMenu: [
      {
        subMenuPageName: "WhatsApp",
        icon: Communication,
        activeIcon: Communication,
        subSubMenu: [
          {
            icon: Communication,
            activeIcon: Communication,
            text: "WhatsApp",
            subtext: "Instant trigger broadcasts via XLSX or CRM leads",
            key: "WhatsApp Marketing",
            link: urls.whatsappMarketingPath,
            pageName: strings.WHATSAPP_MARKETING,
            name: "WhatsApp",
          },
        ],
      },
    ],
  },
  {
    icon: UserIcon,
    activeIcon: UserIcon,
    text: "",
    key: "User List",
    link: urls.customerListViewPath,
    pageName: strings.TEAM,
    name: "Customer",
  },
  {
    icon: Teams,
    activeIcon: Teams,
    text: "",
    key: "Team",
    link: urls.teamViewPath,
    pageName: strings.TEAM,
    name: "Team",
    subMenu: [
      {
        subMenuPageName: "Employee",
        icon: Teams,
        activeIcon: Teams,
        subSubMenu: [
          {
            icon: Teams,
            activeIcon: Teams,
            text: "Team List",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Team List",
            link: urls.teamViewPath,
            pageName: strings.TEAM,
            name: "Team List",
          },
          {
            icon: Teams,
            activeIcon: Teams,
            text: "Archive Team List",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Team List",
            link: urls.archiveMember,
            pageName: strings.ARCHIVEMEMBER,
            name: "Archive Team List",
          },
        ],
      },
      {
        subMenuPageName: "Leaves",
        icon: Leave,
        activeIcon: Leave,
        subSubMenu: [
          {
            icon: Leave,
            activeIcon: Leave,
            text: "All leave",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "All Leaves",
            link: urls.allLeaveViewPath,
            pageName: strings.ALLLEAVE,
            name: "All Leave",
          },
          {
            icon: Leave,
            activeIcon: Leave,
            text: "leave",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Leave",
            link: urls.leaveViewPath,
            pageName: strings.LEAVE,
            name: "My Leave",
          },
          {
            icon: SalarySlip,
            activeIcon: SalarySlip,
            text: "SalarySlip",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Salary",
            link: urls.salarySlipViewPath,
            pageName: strings.SALARYSLIP,
            name: "SalarySlip",
          },
        ],
      },
      {
        subMenuPageName: "Attendance",
        icon: Attendance,
        activeIcon: Attendance,
        subSubMenu: [
          {
            icon: Attendance,
            activeIcon: Attendance,
            text: "All Attendance",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "All Attendance",
            link: urls.attendanceViewpath,
            pageName: strings.ATTENDANCE,
            name: "All Attendance",
          },
          {
            icon: Attendance,
            activeIcon: Attendance,
            text: "My Attendance",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Attendance",
            link: urls.myattendanceViewpath,
            pageName: strings.ATTENDANCE,
            name: "My Attendance",
          },
        ],
      },
    ],
  },
  //    {
  //   icon: Teams,
  //   activeIcon: Teams,
  //   text: "",
  //   key: "CRM",
  //   link: urls.teamViewPath,
  //   pageName: strings.TEAM,
  //   name: "CRM",
  //   subMenu: [
  //     {
  //       subMenuPageName: "CRM",
  //       icon: Teams,
  //       activeIcon: Teams,
  //       subSubMenu: [
  //         {
  //           icon: Teams,
  //           activeIcon: Teams,
  //           text: "Enquiry",
  //           subtext: "Est arcu pharetra proin pellentesque",
  //           key: "Enquiry",
  //           link: urls.enquiryViewPath,
  //           pageName: strings.TEAM,
  //           name: "Enquiry",
  //         },
  //         {
  //           icon: Teams,
  //           activeIcon: Teams,
  //           text: "Customer",
  //           subtext: "Est arcu pharetra proin pellentesque",
  //           key: "Customer",
  //           link: urls.customerViewPath,
  //           pageName: strings.TEAM,
  //           name: "Customer",
  //         },
  //       ],
  //     },
    
  //   ],
  // },
  {
    icon: Clock,
    activeIcon: Clock,
    text: "",
    key: "Meeting",
    link: urls.meetingListViewPath,
    pageName: "Meeting",
    name: "Meeting",
    subMenu: [
      {
        subMenuPageName: "Meeting",
        icon: Clock,
        activeIcon: Clock,
        subSubMenu: [
          {
            icon: Clock,
            activeIcon: Clock,
            text: "Meeting List",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Meeting List",
            link: urls.meetingListViewPath,
            pageName: "Meeting List",
            name: "Meeting List",
          },
          {
            icon: Bills,
            activeIcon: Bills,
            text: "Booking",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Booking",
            link: urls.bookingListViewPath,
            pageName: "Booking",
            name: "Booking",
          },
        ],
      },
    ],
  },
  {
    icon: Projects,
    activeIcon: Projects,
    text: "",
    key: "Project",
    link: urls.PROJECTS,
    pageName: strings.PROJECTS,
    name: "Projects",
    subMenu : [
      {
        subMenuPageName: "Projects",
        icon: Projects,
        activeIcon: Projects,
        subSubMenu :[
          {
            icon: Projects,
            activeIcon: Projects,
            text: "Project List",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Project List",
            link: urls.PROJECTS,
            pageName: strings.PROJECTS,
            name: "Project List",
          },
          {
            icon: SettingsBlack,
            activeIcon: SettingsBlack,
            text: "Aggregator Api",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Project List",
            link: urls.aggregatorApi,
            pageName: strings.AGGREGATOR,
            name: "Aggregator Api",
          },
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Facebook Form",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Project List",
            link: urls.facebookAds,
            pageName: strings.FACEBOOKADS,
            name: "Facebook Form",
          },
        ]
      },
      {
        subMenuPageName: "Bulk Upload",
        icon: FileIcon,
        activeIcon: FileIcon,
        subSubMenu: [
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Bulk Upload by Form",
            subtext: "Form-scoped CSV lead upload (legacy)",
            key: "Bulk Upload Project",
            link: urls.bulkUploade,
            pageName: strings.MYLEADS,
            name: "Bulk Upload by Form",
          },
          {
            icon: FileIcon,
            activeIcon: FileIcon,
            text: "Bulk Upload by Project",
            subtext: "Project-wise CSV lead upload (legacy)",
            key: "Bulk Upload Master",
            link: urls.bulkUploadeProjectwise,
            pageName: strings.BULKUPLOADEPROJECTWISE,
            name: "Bulk Upload by Project",
          },
        ],
      },
    ]
   
  },
  {
    icon: Reports,
    activeIcon: Reports,
    text: "",
    key: "Report",
    link: urls.accountSettingsViewPth, // link to open account setting by default
    pageName: strings.REPORT,
    name: "Report",
    subMenu :[
      {
        subMenuPageName: "Report",
        icon: Reports,
        activeIcon: Reports,
        subSubMenu : [
          // {
          //   icon: SettingsBlack,
          //   activeIcon: SettingsBlack,
          //   text: "Sales Report",
          //   subtext: "Est arcu pharetra proin pellentesque",
          //   key: "Sales Report",
          //   link: urls.salesReports,
          //   pageName: strings.SALESREPORT,
          //   name: "PreSales",
          // },
          {
            icon: Reports,
            activeIcon: Reports,
            text: "Pre Sales Report",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Pre Sales Report",
            link: urls.preSalesReports,
            pageName: strings.PRESALESREPORT,
            name: "PreSales",
          },
          {
            icon: Reports,
            activeIcon: Reports,
            text: "Sales Report",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Sales Report",
            link: urls.salesReports,
            pageName: strings.SALESREPORT,
            name: "Sales",
          },
          // {
          //   icon: SettingsBlack,
          //   activeIcon: SettingsBlack,
          //   text: "Site Visit Report",
          //   subtext: "Est arcu pharetra proin pellentesque",
          //   key: "Site-Visit Report",
          //   link: urls.siteVisitReports,
          //   pageName: strings.SITEVISITSREPORT,
          //   name: "Sales",
          // },
          {
            icon: Reports,
            activeIcon: Reports,
            text: "Source Report",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Source Report",
            link: urls.sourceReports,
            pageName: strings.SOURCESREPORT,
            name: "Source",
          },
        
          {
            icon: Reports,
            activeIcon: Reports,
            text: "Project Report",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Project Report",
            link: urls.projectReports,
            pageName: strings.PROJECTREPORT,
            name: "Project",
          },
          {
            icon: Reports,
            activeIcon: Reports,
            text: "Closure Report",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Closure Report",
            link: urls.closureReports,
            pageName: strings.CLOSUREREPORT,
            name: "Closure",
          },
              {
            icon: Headphones,
            activeIcon: Headphones,
            text: "Call Logs",
            subtext: "IVR calls & recordings",
            key: "Call Logs",
            link: urls.callLogs,
            pageName: strings.CALLLOGS,
            name: "Call Logs",
          },
          {
            icon: Reports,
            activeIcon: Reports,
            text: "Daily Calling Report",
            subtext: "Calls, connect % and assigned leads",
            key: "Daily Calling Report",
            link: urls.callingReport,
            pageName: strings.CALLINGREPORT,
            name: "Daily Calling Report",
          },
        ]
      }
    ]
   
  },
  {
    icon: Settings,
    activeIcon: Settings,
    text: "",
    key: "Setting",
    link: urls.accountSettingsViewPth, // link to open account setting by default
    pageName: strings.SETTINGS,
    name: "Settings",
    subMenu: [
      {

        subMenuPageName: "Settings",
        icon: SettingsBlack,
        activeIcon: SettingsBlack,
        subSubMenu : [
          {
            subMenuPageName: "Settings",
            icon: SettingsBlack,
            activeIcon: SettingsBlack,
            
            text: "Account Settings",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Account",
            link: urls.accountSettingsViewPth,
            pageName: strings.ACCOUNTSETTINNGS,
            name: "Account Settings",
          },
          {
            icon: SettingsBlack,
            activeIcon: SettingsBlack,
            text: "Organizations",
            subtext: "Multi-tenant organizations",
            key: "Organizations",
            link: urls.organizationsAdminPath,
            pageName: strings.SETTINGS,
            name: "Organizations",
          },
          {
            icon: SettingsBlack,
            activeIcon: SettingsBlack,
            text: "Integrations",
            subtext: "Engage, Payment, Housing, 99acres",
            key: "Integrations",
            link: urls.accountIntegrationsPath,
            pageName: strings.SETTINGS,
            name: "Integrations",
          },
          {
            icon: SettingsBlack,
            activeIcon: SettingsBlack,
            text: "Audit Logs",
            subtext: "Team activity tracking",
            key: "AuditLogs",
            link: urls.auditLogsPath,
            pageName: strings.SETTINGS,
            name: "Audit Logs",
          },
          {
            icon: SettingsBlack,
            activeIcon: SettingsBlack,
            text: "Automation Lead Flow",
            subtext: "WhatsApp, routing, IVR workflows",
            key: "Automation",
            link: urls.automationLeadFlowPath,
            pageName: strings.SETTINGS,
            name: "Automation Lead Flow",
          },
          {
            icon: MetaData,
            activeIcon: MetaData,
            text: "Meta Data",
            subtext: "Est arcu pharetra proin pellentesque",
            key: "Meta Data",
            link: urls.metaDataViewPath,
            pageName: strings.MEATADATA,
            name: "Meta Data",
          },
        ]
      },
    ],
  },
  {
    icon: FileIcon,
    activeIcon: FileIcon,
    text: "",
    key: "User Manual",
    link: urls.userManualPath,
    pageName: strings.USER_MANUAL,
    name: "User Manual",
    _stickyBottom: true,
  },
];

export const ListOfMenus1 = [
  {
    icon: Dashboard,
    activeIcon: Dashboard,
    text: "",
    key: "Dashboard",
    link: urls.dashboardViewPath,
    pageName: strings.DASHBOARD,
  },
  {
    icon: Leads,
    activeIcon: Leads,
    text: "",
    key: "Leave",
    link: urls.leaveViewPath,
    pageName: strings.LEAVE,
  },

  {
    icon: Attendance,
    activeIcon: Attendance,
    text: "",
    key: "Attendance",
    link: urls.attendanceViewpath,
    pageName: strings.ATTENDANCE,
  },

  {
    icon: SalarySlip,
    activeIcon: SalarySlip,
    text: "",
    key: "Salary",
    link: urls.salarySlipViewPath,
    pageName: strings.SALARYSLIP,
  },

  {
    icon: SalarySlip,
    activeIcon: SalarySlip,
    text: "",
    key: "team-dashboard",
    link: urls.TeamDashboardViewpath,
    pageName: strings.TEAMDASHBOARD,
  },

  {
    icon: Teams,
    activeIcon: Teams,
    text: "",
    key: "team",
    link: urls.teamViewPath,
    pageName: strings.TEAM,
  },

  {
    icon: Settings,
    activeIcon: Settings,
    text: "",
    key: "setting",
    link: urls.accountSettingsViewPth, // link to open account setting by default
    pageName: strings.SETTINGS,
    subMenu: [
      {
        icon: SettingsBlack,
        activeIcon: SettingsBlack,
        text: "Account Settings",
        subtext: "Est arcu pharetra proin pellentesque",
        key: "account",
        link: urls.accountSettingsViewPth,
        pageName: strings.ACCOUNTSETTINNGS,
      },
      {
        icon: SettingsBlack,
        activeIcon: SettingsBlack,
        text: "Organizations",
        subtext: "Multi-tenant organizations",
        key: "organizations",
        link: urls.organizationsAdminPath,
        pageName: strings.SETTINGS,
      },
      {
        icon: SettingsBlack,
        activeIcon: SettingsBlack,
        text: "Integrations",
        subtext: "Engage, Payment, Housing, 99acres",
        key: "integrations",
        link: urls.accountIntegrationsPath,
        pageName: strings.SETTINGS,
      },
      {
        icon: SettingsBlack,
        activeIcon: SettingsBlack,
        text: "Audit Logs",
        subtext: "Team activity tracking",
        key: "audit-logs",
        link: urls.auditLogsPath,
        pageName: strings.SETTINGS,
      },
      {
        icon: SettingsBlack,
        activeIcon: SettingsBlack,
        text: "Automation Lead Flow",
        subtext: "WhatsApp, routing, IVR workflows",
        key: "Automation",
        link: urls.automationLeadFlowPath,
        pageName: strings.SETTINGS,
      },
      {
        icon: MetaData,
        activeIcon: MetaData,
        text: "Meta Data",
        subtext: "Est arcu pharetra proin pellentesque",
        key: "Meta Data",
        link: urls.metaDataViewPath,
        pageName: strings.MEATADATA,
      },
    ],
  },
  {
    icon: Leads,
    activeIcon: Leads,
    text: "",
    key: "project",
    link: urls.PROJECTS,
    pageName: strings.PROJECTS,
    subMenu: [
      {
        icon: Leads,
        activeIcon: Leads,
        text: "Project List",
        subtext: "Est arcu pharetra proin pellentesque",
        key: "project",
        link: urls.PROJECTS,
        pageName: strings.PROJECTS,
      },
      {
        icon: Leads,
        activeIcon: Leads,
        text: "Project Assets",
        subtext: "Est arcu pharetra proin pellentesque",
        key: "project-assets",
        link: urls.PROJECTSASSETS,
        pageName: strings.PROJECTSASSETS,
      },
      {
        icon: Leads,
        activeIcon: Leads,
        text: "Create Project",
        subtext: "Est arcu pharetra proin pellentesque",
        key: "create-project",
        link: urls.CREATEPROJECT,
        pageName: strings.CREATEPROJECT,
      },
    ],
  },
];
export const AuthMapper = {
  Admin: [
    strings.DASHBOARD,
    strings.SALARYSLIP,
    strings.ATTENDANCE,
    strings.LEAVE, // pending remove this option
    strings.TEAM,
    strings.SETTINGS,
    strings.PROJECTS,
    strings.ROLESANDPRIVILEGES,
    strings.LEADFORMLIST,
    strings.FEEDBACKLIST,
    // strings.SETTINGS_ACCOUNTSETTINNGS,
    // strings.SETTINGS_METADATA,
    // strings.SETTINGS_ACCOUNTSETTINNGS,
    // strings.TEAMDASHBOARD,
    // strings.MEATADATA,
  ],
  Executive: [
    strings.DASHBOARD,
    strings.SALARYSLIP,
    strings.ATTENDANCE,
    strings.LEAVE, // pending remove this option
    strings.TEAM,
    strings.SETTINGS,
    strings.PROJECTS,
    strings.ROLESANDPRIVILEGES,
    strings.LEADFORMLIST,
    strings.FEEDBACKLIST,
    // strings.SETTINGS_ACCOUNTSETTINNGS,
    // strings.SETTINGS_METADATA,
    // strings.SETTINGS_ACCOUNTSETTINNGS,
    // strings.TEAMDASHBOARD,
    // strings.MEATADATA,
  ],
  User: [strings.DASHBOARD,
     strings.SALARYSLIP,
      strings.ATTENDANCE,
       strings.LEAVE
      ],
  Hr: [strings.TEAM,
     strings.DASHBOARD,
      strings.SALARYSLIP,
       strings.ATTENDANCE,
        strings.LEAVE,
         strings.TEAM,
          strings.SETTINGS,
           strings.TEAMDASHBOARD
          ],
} as AuthMap;

export const generateMenu = () => {
  console.log("suyfgjf")
  const userRole = store.getState().auth.role;
  const generatedMenu: any[] = [];
  ListOfMenus.forEach((menu: any) => {
    if (userRole && AuthMapper[userRole]?.includes(menu.pageName)) {
      generatedMenu.push(menu);
    }
  });

  return generatedMenu;
};

export const doesUserHasAccessTo = (componentName: string) => {
  const userRole = store.getState().auth.role ?? "";
  const userAuthorizedPages = AuthMapper[userRole];
  // const userTypeAuthorizedPages = AuthMapper[store.getState().auth.userType];
  return userAuthorizedPages.includes(componentName);
  // return userAuthorizedPages
  //   .concat(userTypeAuthorizedPages)
  //   .includes(componentName);
};

export const generatedSubMenu = (subMenu: any) => {
  const generatedMenu: any[] = [];
  subMenu.forEach((menu: any) => {
    // if (userRole?.includes(menu.pageName)) {
    generatedMenu.push(menu);
    // }y
  });
  return generatedMenu;
};
